import { _ as r } from "../internals/export.js";
import { f as t } from "../internals/function-uncurry-this.js";
import { a as o } from "../internals/a-callable.js";
import { t as n } from "../internals/to-object.js";
import { l as s } from "../internals/length-of-array-like.js";
import { d as i } from "../internals/delete-property-or-throw.js";
import { t as e } from "../internals/to-string.js";
import { f as a } from "../internals/fails.js";
import { a as f } from "../internals/array-sort.js";
import { a as m } from "../internals/array-method-is-strict.js";
import { e as l } from "../internals/engine-ff-version.js";
import { e as c } from "../internals/engine-is-ie-or-edge.js";
import { e as u } from "../internals/engine-v8-version.js";
import { e as p } from "../internals/engine-webkit-version.js";
var v = [],
  j = t(v.sort),
  d = t(v.push),
  h = a(function () {
    v.sort(void 0);
  }),
  g = a(function () {
    v.sort(null);
  }),
  k = m("sort"),
  y = !a(function () {
    if (u) return u < 70;
    if (!l || !(l > 3)) {
      if (c) return !0;
      if (p) return p < 603;
      var r,
        t,
        o,
        n,
        s = "";
      for (r = 65; r < 76; r++) {
        switch (t = String.fromCharCode(r), r) {
          case 66:
          case 69:
          case 70:
          case 72:
            o = 3;
            break;
          case 68:
          case 71:
            o = 4;
            break;
          default:
            o = 2;
        }
        for (n = 0; n < 47; n++) v.push({
          k: t + n,
          v: o
        });
      }
      for (v.sort(function (r, t) {
        return t.v - r.v;
      }), n = 0; n < v.length; n++) t = v[n].k.charAt(0), s.charAt(s.length - 1) !== t && (s += t);
      return "DGBEFHACIJK" !== s;
    }
  });
r({
  target: "Array",
  proto: !0,
  forced: h || !g || !k || !y
}, {
  sort: function sort(r) {
    void 0 !== r && o(r);
    var t,
      a,
      m = n(this);
    if (y) return void 0 === r ? j(m) : j(m, r);
    var l = [],
      c = s(m);
    for (a = 0; a < c; a++) a in m && d(l, m[a]);
    for (f(l, function (t, o) {
      return void 0 === o ? -1 : void 0 === t ? 1 : void 0 !== r ? +r(t, o) || 0 : e(t) > e(o) ? 1 : -1;
    }), t = s(l), a = 0; a < t;) m[a] = l[a++];
    for (; a < c;) i(m, a++);
    return m;
  }
});